<template>
  <div>
    <div class="page-header flex-shrink-0 bg-white border-bottom">
      <div class="container-fluid d-flex justify-content-between px-md-4 px-3">
        <h3 class="my-2">Event Counts</h3>
      </div>
    </div>
    <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3 mt-3">
      <b-table bordered class="mb-5 rg-table" :items="reportData.items" :fields="reportData.fields">
          <template v-slot:cell(month)="data">
            {{ data.item.month | formatDateAsMonth }}
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'EventCountByProperty',
  data () {
    return {
      reportData: {
        items: [],
        fields: [
          {key: 'property', sortable: true},
          {key: 'type', sortable: true},
          {key: 'category', sortable: true},
          {key: 'month', sortable: true},
          {key: 'count', sortable: true} ]
      }
    }
  },
  computed: {
  },
  created () {
    this.doGetReport()
  },
  methods: {
    ...mapActions('reports', ['getEventCountByPropertyReport']),
    doGetReport () {
      this.getEventCountByPropertyReport().then((r) => { this.reportData.items = r.data.reportItems })
    }
  }
}
</script>
<style>
  .sticky-header {
    height: 500px;
  }
</style>
